const map = {
	"./assets/images/home-banner.jpg": 935,
	"./assets/images/home-news.png": 968,
	"./assets/images/news-feb25.jpeg": 678,
	"./assets/images/news-feb6.jpeg": 339,
	"./assets/images/news-oct5.jpeg": 739,
	"./assets/images/ossce-logo.svg": 348,
	"./assets/images/program-onion.png": 627,
	"./assets/images/program-termcard.png": 578,
	"./assets/images/team-asad.jpeg": 493,
	"./assets/images/team-belinda.png": 894,
	"./assets/images/team-cindy.jpg": 936,
	"./assets/images/team-han.jpeg": 475,
	"./assets/images/team-isabel.png": 689,
	"./assets/images/team-julia.jpeg": 969,
	"./assets/images/team-luisa.png": 369,
	"./assets/images/team-rachel.png": 322
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 321;